<script setup>
import { useI18n } from "vue-i18n";
import axios from "axios";
import { eventBus } from "@/utils/eventBus";

const { subscription } = defineProps(["subscription"]);
const emit = defineEmits(["showHistory", "resumeSubscription", "cancelPlan"]);
const { t } = useI18n();

const customerPortalUrl = import.meta.env.VITE_STRIPE_BILLING_PORTAL;

const handleManageSubscription = async () => {
  try {
    const response = await axios.get("/api/user/payments/portal");
    if (response.data && response.data.url) {
      window.open(response.data.url, '_blank');
    }
  } catch (error) {
    console.error("Error accessing payment portal:", error);
  }
};
</script>
<template>
  <div class="icons-container">
    <template v-if="subscription.status === 'canceled'">
      <VBtn
        v-if="subscription.type === 'one_time_payment' || subscription.type === 'gift'"
        @click="eventBus.emit('open-plans-modal')"
        color="primary"
        variant="outlined"
        size="small"
        prepend-icon="mdi-credit-card-plus"
      >
        <span class="btn-text">{{ t("common.subscribe") }}</span>
      </VBtn>

      <VBtn
        v-else-if="subscription.to"
        @click="emit('resumeSubscription')"
        color="warning"
        variant="outlined"
        size="small"
      >
        {{ t("common.resume") }}
      </VBtn>

      <VBtn v-else :href="customerPortalUrl" color="warning" variant="outlined" size="small">
        {{ t("common.resume") }}
      </VBtn>
    </template>

    <template v-else>
      <!-- MANAGE SUBSCRIPTION -->
      <VBtn
        @click="handleManageSubscription"
        color="primary"
        variant="outlined"
        size="small"
        prepend-icon="mdi-cog"
        class="manage-btn"
      >
        <span class="btn-text">{{ t("billing.manage_subscription") }}</span>
      </VBtn>
    </template>
  </div>
</template>
<style scoped lang="scss">
.icons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.icon,
.icon-link {
  transition: 0.2s ease;
  cursor: pointer;
}
.icon:hover {
  filter: brightness(0.6);
}

.manage-btn {
  .btn-text {
    @media (max-width: 768px) {
      display: none;
    }
  }
  
  @media (max-width: 768px) {
    min-width: auto !important;
    padding: 0 8px !important;
  }
}
</style>
